import FuseDialog from '@fuse/core/FuseDialog';
import { styled } from '@mui/material/styles';
import FuseMessage from '@fuse/core/FuseMessage';
import FuseSuspense from '@fuse/core/FuseSuspense';
import AppContext from 'app/AppContext';
import { createContext, memo, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { selectFuseCurrentLayoutConfig } from 'app/store/fuse/settingsSlice';
import FooterLayout1 from './components/FooterLayout1';
import LeftSideLayout1 from './components/LeftSideLayout1';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import RightSideLayout1 from './components/RightSideLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';
import CircularProgress from '@mui/material/CircularProgress';
import jwtDecode from 'jwt-decode';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';

export const userContext = createContext();

const Root = styled('div')(({ theme, config }) => ({
  ...(config.mode === 'boxed' && {
    clipPath: 'inset(0)',
    maxWidth: `${config.containerWidth}px`,
    margin: '0 auto',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  }),
  ...(config.mode === 'container' && {
    '& .container': {
      maxWidth: `${config.containerWidth}px`,
      width: '100%',
      margin: '0 auto',
    },
  }),
}));

const LoadingOverlay = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  zIndex: 9999,
});

function Layout1(props) {
  const config = useSelector(selectFuseCurrentLayoutConfig);
  const isLoading = useSelector(state => state.fuse.settings.isLoading);
  const appContext = useContext(AppContext);
  const [user, setUser] = useState();
  const { routes } = appContext;
 

  return (
    <userContext.Provider value={[user, setUser]} >
      <Root id="fuse-layout" config={config} className="w-full flex">
        {isLoading &&
          <LoadingOverlay style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
            <CircularProgress style={{ color: "#E68718" }} size={80} thickness={5} />
            <p style={{ color: "#E68718", marginTop: 20}}>Loading...</p>
          </LoadingOverlay>
        }

        {config.leftSidePanel.display && <LeftSideLayout1 />}

        <div className="flex flex-auto min-w-0">
          {config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

          <main id="fuse-main" className="flex flex-col flex-auto min-h-full min-w-0 relative z-[21]">
            {config.toolbar.display && (
              <ToolbarLayout1 className={config.toolbar.style === 'fixed' && 'sticky top-0'} />
            )}

            <div className="flex flex-col flex-auto min-h-0 relative overflow-auto">
              <FuseDialog />
              <FuseSuspense>{useRoutes(routes)}</FuseSuspense>
              {props.children}
            </div>

            {config.footer.display && (
              <FooterLayout1 className={config.footer.style === 'fixed' && 'sticky bottom-0'} />
            )}
          </main>

          {config.navbar.display && config.navbar.position === 'right' && <NavbarWrapperLayout1 />}
        </div>

        {config.rightSidePanel.display && <RightSideLayout1 />}
        <FuseMessage />
      </Root>
    </userContext.Provider>
  );
}

export default memo(Layout1);
